import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faExclamation, faCheck } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { AlertWrapper, AlertBox, AlertIcon, AlertText, CloseButton } from './styled';
const alertStatuses = {
  error: {
    icon: faExclamationTriangle,
    getColor: props => props.theme.colors.error
  },
  success: {
    icon: faCheck,
    getColor: props => props.theme.colors.primary
  }
};
const alertSchema = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(Object.keys(alertStatuses))
};
const AlertsView = props => {
  const {
    icon,
    getColor
  } = alertStatuses[props.alert.type] || {
    icon: faExclamation,
    getColor: () => props.theme.colors.primary
  };
  return /*#__PURE__*/React.createElement(AlertWrapper, {
    key: props.alert.id
  }, /*#__PURE__*/React.createElement(AlertBox, null, /*#__PURE__*/React.createElement(AlertIcon, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    color: getColor(props),
    size: "2x",
    fixedWidth: true
  })), /*#__PURE__*/React.createElement(AlertText, null, props.alert.message), /*#__PURE__*/React.createElement(CloseButton, {
    value: props.alert.id,
    onClick: props.removeAlert(props.alert.id),
    disabled: props.disableRemove
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimesCircle,
    color: props.theme.colors.tertiary,
    size: "lg",
    fixedWidth: true
  }))));
};
AlertsView.propTypes = {
  alert: PropTypes.shape(alertSchema).isRequired,
  theme: PropTypes.object.isRequired,
  removeAlert: PropTypes.func.isRequired,
  disableRemove: PropTypes.bool
};
export default withTheme(AlertsView);